'use client';

// Third Party Plugins
import React from 'react';
// Types
import { PastGrantWinnersListProps } from './types';
// Custom Components
import PostCard from '@/components/cards/PostCard';
import CardGridContainer from '@/components/cards/CardGridContainer';

const PastGrantWinnersList: React.FC<PastGrantWinnersListProps> = ({
  winners,
}) => {
  return (
    <CardGridContainer>
      {winners.map((winner) => (
        <PostCard
          _id={winner._id}
          key={winner._id}
          image={winner.pastWinnerImg?.asset?.url}
          altText={winner.pastWinnerImg?.alt}
          tagText={winner.pastGrantWinnerTag}
          type={winner._type}
          to={`/past-grant-winners/${winner.slug.current}`}
          title={winner.pastGrantWinnerTitle}
          description={winner.pastGrantWinnerContentExcerpt}
          date={winner.publishDate}
        />
      ))}
    </CardGridContainer>
  );
};

export default PastGrantWinnersList;
